import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import RouteLayout from 'components/RouteLayout';
import { ESOP_OPEN_ACCOUNT_REDIRECT } from 'utils/constants';
import Open from './Open';

const ESOP: React.FC = () => {
    const [searchParams] = useSearchParams();
    const redirect = searchParams.get('redirect');

    useEffect(() => {
        if (redirect) {
            sessionStorage.setItem(ESOP_OPEN_ACCOUNT_REDIRECT, redirect);
        }
    }, [redirect]);

    const commonRoute = (
        <>
            <Route path="signup/*" element={<Open />} />
            <Route path="*" element={<Navigate to="signup" replace />} />
        </>
    );

    return (
        <div className="page-esop-root">
            <Routes>
                <Route element={<RouteLayout />}>{commonRoute}</Route>
                <Route path=":customerId/*" element={<RouteLayout />}>
                    {commonRoute}
                </Route>
            </Routes>
        </div>
    );
};

export default ESOP;
